import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/sIcon.png'
import _imports_1 from '@/assets/uIcon.png'
import _imports_2 from '@/assets/float.png'


const _withScopeId = n => (_pushScopeId("data-v-0b562dd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "careAssingnmentLayout",
  ref: "careAssingnmentLayout",
  class: "care-assingnment"
}
const _hoisted_2 = { style: {"text-align":"left"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title care-assignment-header" }, " Care Assignment Sheet ", -1))
const _hoisted_4 = { class: "col-sm-12 div-filter" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Facility:", -1))
const _hoisted_6 = { class: "care-assignment-title-value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Service Line:", -1))
const _hoisted_8 = { class: "care-assignment-title-value" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Department:", -1))
const _hoisted_10 = { class: "care-assignment-title-value" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Date:", -1))
const _hoisted_12 = { class: "care-assignment-title-value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "care-assignment-title" }, "Summary Period:", -1))
const _hoisted_14 = { class: "care-assignment-title-value" }
const _hoisted_15 = { class: "care-assignment-title-value" }
const _hoisted_16 = {
  id: "careAssignmentSkill",
  class: "care-assignment-skill"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "padding" }, null, -1))
const _hoisted_18 = { id: "grdCareAssignment" }
const _hoisted_19 = {
  border: "1",
  class: "tableClass"
}
const _hoisted_20 = {
  header: "",
  class: "tableRow",
  style: {"padding-top":"25px !important","padding-bottom":"10px !important"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"15%"}
}, " Name ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"6%"}
}, " Skill ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"13%"}
}, " Department ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"6%"}
}, " Shift ", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"7%"}
}, " Start Time ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"7%"}
}, " End Time ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"5%"}
}, " Type ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"5%"}
}, " Hours ", -1))
const _hoisted_29 = {
  key: 0,
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"7%"}
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Room/Assignment ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Additional Notes ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Competency ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, " Credentials ", -1))
const _hoisted_34 = { align: "left" }
const _hoisted_35 = ["slot", "uid", "staffId"]
const _hoisted_36 = ["title"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "associaionIcon",
  title: "Secondary Association"
}, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { key: 2 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "associaionIcon",
  title: "Unassociated"
}, null, -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { key: 3 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"24px","float":"right"},
  src: _imports_2,
  alt: "Float"
}, null, -1))
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = ["title"]
const _hoisted_48 = ["title"]
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = { style: {"text-decoration":"line-through"} }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  slot: "Room/Assignment",
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  slot: "Additional Notes",
  class: "tableRowHeading tableRowHeading_large",
  style: {"width":"10%"}
}, null, -1))
const _hoisted_55 = {
  slot: "Competency",
  style: {"width":"10%"},
  class: "tableRow_cell"
}
const _hoisted_56 = {
  slot: "Credentials",
  style: {"width":"10%"},
  class: "tableRow_cell"
}
const _hoisted_57 = {
  key: 0,
  id: "careAssignmentMessage",
  class: "care-no-assingnments",
  style: {"padding-top":"25px !important","padding-bottom":"10px !important"}
}
const _hoisted_58 = { id: "home-message-text" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "padding" }, null, -1))
const _hoisted_60 = {
  key: 1,
  id: "careAssignmentFooter",
  class: "care-assignment-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.careAssignmentViewModel.facilityName), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.careAssignmentViewModel.serviceLineName), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.careAssignmentViewModel.departmentName), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.careAssignmentViewModel.startDate), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.careAssignmentViewModel.startTime), 1),
          _createTextVNode(" - "),
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.careAssignmentViewModel.endTime), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.careAssignmentSkillDetails), 1)
        ])
      ])
    ]),
    _hoisted_17,
    _withDirectives(_createElementVNode("div", _hoisted_18, [
      _createElementVNode("table", _hoisted_19, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_20, [
            _hoisted_21,
            _hoisted_22,
            _hoisted_23,
            _hoisted_24,
            _hoisted_25,
            _hoisted_26,
            _hoisted_27,
            _hoisted_28,
            (_ctx.isRNExperienceFeatureEnabled)
              ? (_openBlock(), _createElementBlock("th", _hoisted_29, " RN Experience "))
              : _createCommentVNode("", true),
            _hoisted_30,
            _hoisted_31,
            _hoisted_32,
            _hoisted_33
          ])
        ]),
        _createElementVNode("tbody", _hoisted_34, [
          (_ctx.careAssignmentData != null && _ctx.careAssignmentData.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.careAssignmentData, (dataItem) => {
                return (_openBlock(), _createElementBlock("tr", {
                  slot: _ctx.column,
                  key: dataItem,
                  uid: dataItem.uid,
                  staffId: dataItem.staffId,
                  class: _normalizeClass([dataItem.productiveId == 2 ? 'other-productive': '',
                            dataItem.productiveId==3 ? 'non-productive' : '' ,
                            dataItem.productiveId==4 ? 'call-assignment' : '' ,
                            dataItem.profileCharge && dataItem.charge ? 'chargeAssignment' : '' ,
                            (dataItem.cancelReasonId ||
                            (dataItem.cancelComment && dataItem.cancelComment.length>
                            0) || dataItem.isCancelled) ? 'cancelledAssignment': '',
                            dataItem.origDepartmentId !== dataItem.departmentId && !(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'floatedAssignment' : '','tableRow'])
                }, [
                  _createElementVNode("td", {
                    class: "tableRow_cell",
                    slot: "Name",
                    title: dataItem.name,
                    style: {"width":"15%"}
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass([(dataItem.departmentId !== _ctx.payloadCareAssignment.departmentId ) ? 'strikethrough employee-col' : ''])
                    }, _toDisplayString(dataItem.name), 3),
                    (dataItem.charge)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fa', 'user-md'],
                            size: "sm",
                            style: {"float":"right","font-size":"16px"}
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (dataItem.associationType === _ctx.associationTypes.secondary)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_38, _hoisted_40))
                      : _createCommentVNode("", true),
                    (dataItem.associationType === _ctx.associationTypes.unassociated)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, _hoisted_43))
                      : _createCommentVNode("", true),
                    (dataItem.isFloat)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_44, _hoisted_46))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_36),
                  _createElementVNode("td", {
                    slot: "Skill",
                    title: dataItem.skillLevelDescription,
                    style: {"width":"6%"},
                    class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                        (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadCareAssignment.departmentId === dataItem.origDepartmentId) ? 'strikethrough' : '','tableRow_cell'])
                  }, _toDisplayString(dataItem.skillLevelDescription), 11, _hoisted_47),
                  _createElementVNode("td", {
                    slot: "Department",
                    title: dataItem.departmentName,
                    style: {"width":"13%"},
                    class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': ''
                               
                                ])
                  }, [
                    (dataItem.origDepartmentId !== dataItem.departmentId)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_49, [
                          _createTextVNode(_toDisplayString(dataItem.departmentName) + " ", 1),
                          _hoisted_50,
                          _createElementVNode("span", _hoisted_51, _toDisplayString(dataItem.origDepartmentName), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(dataItem.departmentName), 1))
                  ], 10, _hoisted_48),
                  _createElementVNode("td", {
                    slot: "Shift",
                    style: {"width":"6%"},
                    class: _normalizeClass([dataItem.overtimeShift ? 'gridOverTime': '',
                                (dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length>
                                0) || dataItem.isCancelled) ? 'strikethrough': '',
                                (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadCareAssignment.departmentId === dataItem.origDepartmentId) ? 'strikethrough' : '','tableRow_cell'])
                  }, _toDisplayString(dataItem.shiftCode), 3),
                  _createElementVNode("td", {
                    slot: "Start Time",
                    style: {"width":"7%"},
                    class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                    (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadCareAssignment.departmentId === dataItem.origDepartmentId) ? 'strikethrough' : '','tableRow_cell'])
                  }, _toDisplayString(_ctx.setGridTimeFormat(dataItem.actualStartTime)), 3),
                  _createElementVNode("td", {
                    slot: "End Time",
                    style: {"width":"7%"},
                    class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                    (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadCareAssignment.departmentId === dataItem.origDepartmentId) ? 'strikethrough' : '','tableRow_cell'])
                  }, _toDisplayString(_ctx.setGridTimeFormat(dataItem.actualEndTime)), 3),
                  _createElementVNode("td", {
                    slot: "Type",
                    style: {"width":"5%"},
                    class: _normalizeClass([(dataItem.cancelReasonId || (dataItem.cancelComment && dataItem.cancelComment.length > 0) || dataItem.isCancelled) ? 'strikethrough': '',
                                    (dataItem.origDepartmentId !== dataItem.departmentId && _ctx.payloadCareAssignment.departmentId === dataItem.origDepartmentId) ? 'strikethrough' : '','tableRow_cell'])
                  }, _toDisplayString(dataItem.employeeType), 3),
                  _createElementVNode("td", {
                    slot: "Hours",
                    style: {"width":"5%"},
                    class: _normalizeClass([dataItem.isOvertime ? 'gridOverTime': '','tableRow_cell'])
                  }, _toDisplayString(dataItem.hours), 3),
                  (dataItem.rnExperienceFeatureEnabled)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 0,
                        slot: "RN Experience",
                        style: {"width":"7%"},
                        class: _normalizeClass([dataItem.rnExperience == '< 1 Year' ? 'rn-experience': '','tableRow_cell'])
                      }, _toDisplayString(dataItem.rnExperience), 3))
                    : _createCommentVNode("", true),
                  _hoisted_53,
                  _hoisted_54,
                  _createElementVNode("td", _hoisted_55, _toDisplayString(dataItem.competencyCodes), 1),
                  _createElementVNode("td", _hoisted_56, _toDisplayString(dataItem.credentialCode), 1)
                ], 10, _hoisted_35))
              }), 128))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, _ctx.isShowCareAssignmentContent]
    ]),
    (_ctx.isShowCareAssignmentMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.careAssignmentMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_59,
    (_ctx.careAssignmentFooterText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.careAssignmentFooterText), 1))
      : _createCommentVNode("", true)
  ], 512))
}